import api from './authService'

export interface RequirementData {
    id?: string
    title: string
    description?: string
    type: string
    status: string
    priority?: string
    screens?: string
    personas?: string
    projectId?: string
    parentId: string | null
    linkedIds?: string[] | null
    isVerified?: boolean
}

export const requirementService = {
    async getRequirements(params?: any) {
        const response = await api.get('/requirements', { params })
        return response.data
    },

    async getRequirement(id: string) {
        const response = await api.get(`/requirements/${id}`)
        return response.data
    },

    async createRequirement(data: RequirementData) {
        const response = await api.post('/requirements', data)
        return response.data
    },

    async updateRequirement(id: string, data: Partial<RequirementData>) {
        const response = await api.put(`/requirements/${id}`, data)
        return response.data
    },

    async deleteRequirement(id: string) {
        const response = await api.delete(`/requirements/${id}`)
        return response.data
    },

    async bulkVerifyRequirements(projectId: string | number, type: string, isVerified: boolean) {
        const response = await api.put(`/requirements/project/${projectId}/bulk-verify`, { type, isVerified })
        return response.data
    }
}
